// Compliant with ISO5218 & Engine
export enum Gender {
  MALE = 1,
  FEMALE = 2,
}
